<div id="valoracion-clientes" class="px-4 px-lg-5 py-5 bg-primary-50">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-10 col-xl-8 mx-auto text-center">
        <p class="tab-ancla primary-500 mb-2">LA OPINIÓN DE NUESTROS CLIENTES</p>
        <h1 class="primary-900">Nuestros usuarios nos valoran</h1>
      </div>
    </div>
    <div class="row mt-4 mt-lg-5">
      <div class="swiper swiperValoracion" id="swiper-valoracion">
        <div class="swiper-wrapper">
          @for (valoracion of valoraciones; track valoracion) {
            <div class="swiper-slide">
              <app-ficha-valoracion-cliente [valoracion]="valoracion"></app-ficha-valoracion-cliente>
            </div>
          }
        </div>
        <div class="mt-4 mt-lg-5">
          <div class="swiper-pagination swiper-valoracion-clientes"></div>
        </div>
      </div>
    </div>
  </div>
</div>